import cn from 'classnames';
import s from './Emdash.module.less';

type Props = { muted?: boolean };
export default function Emdash({ muted = true }: Props) {
  // eslint-disable-next-line react/jsx-no-literals
  return <span className={cn({ [s.muted]: muted })}>—</span>;
}
